import { CSSProperties } from 'react';

export const s3IconStyles = {
    loadingIcon: (width: number | string, height: number | string, style?: CSSProperties): CSSProperties => ({
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'inline-block',
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        animation: 'pulse 1.5s ease-in-out infinite',
        ...style,
    }),
    errorIcon: (width: number | string, height: number | string, style?: CSSProperties): CSSProperties => ({
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        ...style,
    }),
};


